import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  IconButton,
} from "@mui/material";
import { PushNotif } from "../../types/General";
import {
  useDeleteRecieveMutation,
  useLazyReceiveNotificationQuery,
} from "../../services/notifications";
import { isValidInput } from "../../utils/validations";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import moment from "moment";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import { showError, showToast } from "../../constants/toasts";

const RecievedNotifications = () => {
  const navigate = useNavigate();
  const [deleteNotification] = useDeleteRecieveMutation();
  const [notifcationMethod] = useLazyReceiveNotificationQuery();

  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState(0);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [rows, setRows] = useState<PushNotif[]>([]);
  const [selectedId, setSelectedId] = useState<string>("");
  const [openDelete, setOpenDelete] = useState(false);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const getNotification = async () => {
    setIsLoading(true);
    try {
      const response = await notifcationMethod({
        page: page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.statusCode === 200) {
        setIsLoading(false);
        setCount(response?.data?.count);
        setRows(response?.data?.data || []);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await deleteNotification({
        id: selectedId || "",
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast("Notification delete successfully");
      }
    } catch (error: any) {
      showError(error?.message);
      //   setIsLoading(false);
    } finally {
      getNotification();
    }
  };
  useEffect(() => {
    getNotification();
  }, [debouncedSearchTerm, page]);

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "title",
      headerName: "Title",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 150,
      field: "message",
      headerName: "Message",
      editable: false,
      sortable: false,
    },
    {
      minWidth: 150,
      field: "date",
      headerName: "Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{moment(row?.createdAt).format("DD MMM YYYY")}</p>
          </div>
        );
      },
    },
    {
      minWidth: 100,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Recieved Notifications</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Recieved Notifications
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              placeholder="Search..."
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </div>
        </div>
        <div className="sorting_table">
          <TableComponent
            columns={columns}
            rows={rows}
            count={count}
            page={page}
            onPageChange={handlePageChange}
            loading={isLoading}
          />
        </div>
      </div>
      <ConfirmationModal
        text="Are you sure to delete this notification"
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
    </MainContainer>
  );
};

export default RecievedNotifications;
